import React from "react";
import Routes from "../../../../Routes";
import CardsMenu from "../../../../components/admin/menus/CardsMenu";
export default function NewProductsMenu() {
  return <CardsMenu routes={Routes} father="/productos/new-product" />;
}
